module.exports = __webpack_public_path__ + "static/img/9.96a9a62.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/sp/9.png
// module id = m9+U
// module chunks = 0